<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormLayout
          headline="Create Event"
          :errors="errors"
          :company-id="portalCompany.attributes.company_id"
          :content-event-categories="contentEventCategories"
          :portal="portal"
          :initial="initial"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import FormLayout from '../../../../../../../../components/Administration/ContentEvents/Layouts/Form'
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormLayout, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    portalCompanyId: {
      required: true
    }
  },

  data() {
    return {

      portalCompany: null,
      contentEventCategories: null,

      loading: true,

      errors: {},

      initial: {
        content_bodies: [],
        publish_at: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portal-companies/' + this.portalCompanyId),
        http.get('/api/v2/content-event-categories', {'filter[portal_id]': this.portal.id})
      ]).then(responses => {
        this.portalCompany = responses[0].data.data

        this.contentEventCategories = responses[1].data.data

        this.loading = false

      })
    },

    submit(data) {
      http.post('/api/v2/content-events', {...data, portal_company_id: this.portalCompanyId})
          .then(() => {
            notify.success('The content event was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/events')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
